export const FEATURE_FLAGS_CONTAINER_SX = {
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
} as const;

export const FLAG_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: 1,
  borderBottom: '1px solid',
  borderColor: 'divider',
} as const;
